var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRideTrackingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00---Home",
    transform: "translate(-253.000000, -726.000000)",
    fill: "#444B68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.44375,725.709131 L266.8875,738.709131 L256,738.709131 L261.44375,725.709131 Z M261.44375,735.621631 L256,738.709131 L266.8875,738.709131 L261.44375,735.621631 Z",
    id: "Combined-Shape",
    transform: "translate(261.443750, 732.209131) rotate(-330.000000) translate(-261.443750, -732.209131) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRideTrackingSmall);
export default __webpack_public_path__ + "static/media/iconRideTrackingSmall.1c7f6a9689832fbab635381204d5d011.svg";
export { ForwardRef as ReactComponent };